<script>
    import { onMount } from "svelte";
    import LoadingEllipsis from "$lib/UI/LoadingEllipsis.svelte";
    import Markdown from "$lib/UI/Markdown.svelte";
  
    let mdContent = "";
    let isLoading = false;
    

    onMount(() => {
        const hashPage = window.location.hash;
        if (!!hashPage && hashPage.length > 1) {
            const page = hashPage.substring(1);
            isLoading = true;
            let headers = undefined;
           
            fetch("/api/config/doc/" + page, {
                method: "GET",
                headers: headers,
            })
                .then((res) => {
                    res.text()
                        .then((tx) => {
                            mdContent = tx;
                            isLoading = false;
                        })
                        .catch(() => {
                            isLoading = false;
                        });
                })
                .catch(() => {});
        }
    });
</script>

<div>
    {#if isLoading}
        <LoadingEllipsis />
    {:else}
    <Markdown md={mdContent} />
    {/if}
</div>
